import { render, staticRenderFns } from "./InstituteChainInstitutes.vue?vue&type=template&id=33af03f3"
import script from "./InstituteChainInstitutes.vue?vue&type=script&lang=js"
export * from "./InstituteChainInstitutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports